import { ScheduledMessage, SendScheduledMessage, SendScheduledTemplateMessage } from '../types/scheduledMessage';
import baseApi from './baseApi';

const scheduledMessagesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    postScheduledMessage: build.mutation({
      query: (body: SendScheduledMessage) => ({
        url: `/clients/${body.clientId}/scheduledMessages`,
        method: 'POST',
        body: {
          text: body.text,
          postAt: body.postAt,
        },
      }),
      transformResponse: (response: ScheduledMessage) => response,
    }),
    postScheduledTemplateMessage: build.mutation({
      query: (body: SendScheduledTemplateMessage) => ({
        url: `/clients/${body.clientId}/scheduledTemplateMessages`,
        method: 'POST',
        body: {
          templateName: body.templateName,
          components: body.components,
          postAt: body.postAt,
        },
      }),
      transformResponse: (response: ScheduledMessage) => response,
    }),
    deleteScheduledMessage: build.mutation({
      query: ({ clientId, scheduledMessageId }: { clientId: number; scheduledMessageId: number }) => ({
        url: `/clients/${clientId}/scheduledMessages/${scheduledMessageId}`,
        method: 'DELETE',
      }),
      transformResponse: (response: ScheduledMessage) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostScheduledMessageMutation,
  usePostScheduledTemplateMessageMutation,
  useDeleteScheduledMessageMutation,
} = scheduledMessagesApi;
